import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { login } from "@Api/Auth";
import Button from "@Components/Button";
import Form, { InputType } from "@Components/Form";
// import Checkbox from "@Components/Form/Checkbox"
import ArrowRight from "@Components/Icons/ArrowRight";
import PredictyIconEyesOpen from "@Components/Icons/ChatBot/Predicty/PredictyEyesOpen";
import buttons from "@Components/Sass/buttons.module.scss";
import { ERROR, ToastStatus } from "@Components/Toast";
import GetPath from "@Helpers/GetPath";
import { isPlatform } from "@Helpers/GetSubdomain";
import { ROOT as REGISTER_ROOT } from "@Shared/Paths/Register";
import { validation } from "@Shared/Validate";
import { addNotification } from "@Store/Actions/Notifications";
import { RESET } from "@Shared/Paths/Auth";
import { boot } from "@Store/Actions/Auth";
import LoginConstraints from "../../../LoginConstraints";
import styles from "./../index.module.scss";
class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: { username: "", password: "" },
            errors: {},
        };
    }
    inputChange = (data) => {
        this.setState({ data });
    };
    login = async () => {
        const { username, password } = this.state.data;
        try {
            this.setState({ errors: {} });
            validation({ username, password }, LoginConstraints);
            try {
                await login(username, password);
                this.props.boot();
            }
            catch {
                this.props.notify({
                    title: "Failed to log in",
                    description: "Username or password incorrect",
                    status: ERROR,
                });
                this.setState({
                    errors: { username: true, password: true },
                });
            }
        }
        catch ({ fails }) {
            this.setState({ errors: fails });
            this.props.notify({
                title: "Oops!",
                description: "Invalid login details",
                status: ToastStatus.Error,
            });
        }
    };
    render() {
        const registerView = isPlatform();
        return (React.createElement("div", { className: styles.mainContent },
            React.createElement("div", { className: styles.centered },
                React.createElement(PredictyIconEyesOpen, { className: styles.logo })),
            React.createElement("div", { className: styles.heading },
                React.createElement("h1", { className: styles.title }, "Log in to your account"),
                React.createElement("p", { className: styles.subtitle }, "Welcome back! Please enter your details.")),
            React.createElement(Form, { className: styles.form, submit: this.login, labelLeft: false, input: [
                    {
                        label: "Email",
                        name: "username",
                        className: styles.inputForm,
                        inputClassName: styles.inputInner,
                        type: InputType.TextNew,
                    },
                    {
                        label: "Password",
                        name: "password",
                        className: styles.inputForm,
                        inputClassName: styles.inputInner,
                        type: InputType.PasswordNew,
                    },
                ], buttons: false, change: this.inputChange, data: this.state.data, errors: this.state.errors },
                React.createElement("div", { className: styles.checkboxRow },
                    React.createElement("div", { className: styles.forgotPasswordLink },
                        React.createElement(NavLink, { to: GetPath(RESET), exact: true }, "Forgot password"))),
                React.createElement("div", { className: styles.login },
                    React.createElement("div", { className: `${buttons.buttonGroupCenter} ${styles.noMargin}` },
                        React.createElement(Button, { cta: true, type: "submit" }, "LOG IN")))),
            registerView === true && (React.createElement("div", { className: styles.signupSection },
                React.createElement("p", { className: styles.signupText },
                    "New to ",
                    React.createElement("strong", null, "Predict...")),
                React.createElement(NavLink, { to: GetPath(REGISTER_ROOT), className: styles.startTenderButton },
                    React.createElement("span", null, "START A TENDER"),
                    React.createElement(ArrowRight, { className: styles.iconRight }))))));
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        // dispatching plain actions
        boot: () => boot(dispatch),
        notify: (data) => addNotification(dispatch, data),
    };
};
export default connect(null, mapDispatchToProps)(Login);
